import { ElementRef, EventEmitter } from '@angular/core';
import { CommonService } from '../../../app/common.service';
var ComponentQuestionnaireTextarea = (function () {
    function ComponentQuestionnaireTextarea(el, commonService) {
        this.el = el;
        this.commonService = commonService;
        this.outPutTextareaContext = new EventEmitter(); //回传textarea的value
        this.isShowPlaceholder = true; //是否显示placeholder
    }
    ComponentQuestionnaireTextarea.prototype.ngOnInit = function () {
        this.textarea = this.el.nativeElement.querySelector('textarea');
    };
    ComponentQuestionnaireTextarea.prototype.ngAfterViewInit = function () {
    };
    ComponentQuestionnaireTextarea.prototype.ngOnChanges = function (changes) {
        if (changes.selectedTag) {
            this.showSelectedTag();
        }
    };
    //展示选择的标签
    ComponentQuestionnaireTextarea.prototype.showSelectedTag = function () {
        var target = this.el.nativeElement.querySelector('textarea');
        target.value = this.selectedTag;
        this.outPutTextareaContext.emit(target.value);
    };
    //隐藏Placeholder
    ComponentQuestionnaireTextarea.prototype.closePlaceholder = function () {
        this.isShowPlaceholder = false;
        this.textarea.focus();
    };
    //textarea获取焦点事件
    ComponentQuestionnaireTextarea.prototype.textareaFocus = function () {
        this.isShowPlaceholder = false;
    };
    //textarea失去焦点触发事件
    ComponentQuestionnaireTextarea.prototype.textareaBlur = function () {
        this.commonService.initPage();
        this.isShowPlaceholder = this.textarea.value === "" ? true : false;
        this.outPutTextareaContext.emit(this.textarea.value);
    };
    return ComponentQuestionnaireTextarea;
}());
export { ComponentQuestionnaireTextarea };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-textarea/component.questionnaire-textarea.ts.pre-build-optimizer.js